import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { mediaQuery } from '@lacedltd/laced-components'
import type { CSSObject } from '@emotion/styled'

export const Toggle = styled.span<StylesProps>(
  ({ size, active, disabled, loading, fullWidth, as }) => {
    const smallStyles: CSSObject = {
      padding: `${tokens.spacing[3]} ${tokens.spacing[2]}`,
      minWidth: '3rem'
    }

    const largeStyles: CSSObject = {
      padding: `${tokens.spacing[5]} ${tokens.spacing[2]}`,
      minWidth: '5rem'
    }

    const activeStyles: CSSObject = {
      color: tokens.color.airJordan.p,
      outline: `${tokens.borderWidth.s} solid ${tokens.color.airJordan.p}`,
      outlineOffset: `${tokens.borderWidth.s}`
    }

    const disabledStyles: CSSObject = {
      color: tokens.color.airJordan[500],
      backgroundColor: tokens.color.superstar[600],
      pointerEvents: 'none',

      [mediaQuery.m.min]: {
        '&:hover': {
          cursor: 'not-allowed'
        }
      }
    }

    const loadingStyles: CSSObject = {
      pointerEvents: 'none'
    }

    return {
      display: 'flex',
      alignItems: 'center',
      color: tokens.color.airJordan[600],
      justifyContent: 'center',
      fontSize: tokens.fontSize[1],
      outline: `${tokens.borderWidth.xs} solid ${tokens.color.airJordan[200]}`,
      outlineOffset: tokens.borderWidth.xs,
      textTransform: 'uppercase',
      textAlign: 'center',

      [mediaQuery.m.min]: {
        '&:hover': {
          cursor: 'pointer'
        }
      },

      ...(size === 'small' ? smallStyles : largeStyles),
      ...(active && activeStyles),
      ...(disabled && disabledStyles),
      ...(loading && loadingStyles),
      ...(fullWidth && { width: '100%' }),
      ...(as === 'label' && { marginBottom: '0 !important' })
    }
  }
)

export const ToggleCollapseContainer = styled.div<{
  multiLine?: boolean
  hidden?: boolean
}>(({ multiLine = false, hidden = false }) => ({
  display: 'grid',
  gap: tokens.borderWidth.xs,
  gridAutoFlow: 'column',
  isolation: 'isolate',

  ...(multiLine && {
    gridTemplateColumns: 'repeat(auto-fill, minmax(5rem, 1fr))',
    gridAutoFlow: 'unset'
  }),

  ...(hidden && {
    display: 'none'
  }),

  'span, label': {
    // when in the collapse grid container, allow outline to sit outside of element by 1px
    // this should fill the grid gap and collapse adjacent borders
    outlineOffset: 'unset'
  },

  '[data-active]': {
    // bring back outline by 1px, so it overflows the element by 1px. This should fill the
    // grid gap, and collapse two adjacent outlines
    outlineOffset: `-${tokens.borderWidth.xs}`,

    // brings the element (and its outline) on top
    // safe to hard code 1 because of isolation: isolate on the container
    zIndex: 1,
    position: 'relative'
  }
}))

interface StylesProps {
  size: 'small' | 'large'
  active?: boolean
  disabled?: boolean
  loading?: boolean
  fullWidth?: boolean
  as?: 'span' | 'label'
}
